import React, { useRef, useState } from 'react';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiSortVariant, mdiCalendarToday, mdiArrowRight, mdiLightbulb } from '@mdi/js';
import './budget-impacts-page.m.css';

const SORT_OPTIONS = [
  { label: `Low → High`, value: 'low-to-high' },
  { label: `High → Low`, value: 'high-to-low' },
];

const COMPARE_OPTIONS = [
  { label: '1 Day', value: '1d' },
  { label: '1 Week', value: '1w' },
  { label: '1 Month', value: '1m' },
];

const formatDate = (date) => {
  console.log('date = ', date);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

const FilterControls = ({ sortOrder, setSortOrder, compareRange, setCompareRange, getFromDate }) => {
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [isCompareOpen, setIsCompareOpen] = useState(false);
  const currentDate = new Date();

  const sortTimeoutRef = useRef(null);
  const compareTimeoutRef = useRef(null);

  const handleSortEnter = () => {
    clearTimeout(sortTimeoutRef.current);
    setIsSortOpen(true);
    setIsCompareOpen(false);
  };
  const handleSortLeave = () => {
    sortTimeoutRef.current = setTimeout(() => setIsSortOpen(false), 200);
  };
  const handleSortToggle = () => {
    setIsSortOpen((prev) => !prev);
    setIsCompareOpen(false);
  };
  const handleCompareEnter = () => {
    clearTimeout(compareTimeoutRef.current);
    setIsCompareOpen(true);
    setIsSortOpen(false);
  };
  const handleCompareLeave = () => {
    compareTimeoutRef.current = setTimeout(() => setIsCompareOpen(false), 200);
  };
  const handleCompareToggle = () => {
    setIsCompareOpen((prev) => !prev);
    setIsSortOpen(false);
  };

  const onClickCompareOption = (option) => {
    setCompareRange(option.value);
    setIsCompareOpen(false);
  };

  const onClickSortOption = (option) => {
    setSortOrder(option.value);
    setIsSortOpen(false);
  };

  const getSortOptions = (type = 'default', option = {}) => {
    if (type === 'default') {
      const defaultLabels = SORT_OPTIONS.find(o => o.value === sortOrder)?.label.split('→');
      return (
        <span styleName="filter-value">{defaultLabels[0].trim()} <Icon path={mdiArrowRight} size="14px" /> {defaultLabels[1].trim()} <Icon path={mdiChevronDown} size="16px" /></span>
      );
    } else if (type === 'all') {
      const labels = option?.label.split('→');
      return (
        <button
          key={option.value}
          styleName={`filter-option ${sortOrder === option.value ? 'active' : ''}`}
          onClick={() => onClickSortOption(option)}
        >
          {labels[0].trim()} <Icon path={mdiArrowRight} size="14px" /> {labels[1].trim()}
        </button>
      );
    }
  };

  const fromDate = getFromDate(compareRange);
  const compareLabel = `${formatDate(fromDate)}`;

  return (
    <div styleName="filter-controls">
      {/* Sort By Dropdown */}
      <div styleName="filter-dropdown sort" onMouseEnter={handleSortEnter} onMouseLeave={handleSortLeave}>
        <button
          styleName="filter-btn"
          onClick={handleSortToggle}
        >
          <span styleName="filter-icon">
            <Icon path={mdiSortVariant} size="24px" />
          </span>
          <div styleName="filter-text">
            <span styleName="filter-label">SORT BY IMPACT</span>
            {getSortOptions()}
          </div>
        </button>
        {isSortOpen && (
          <div styleName="filter-menu">
            {SORT_OPTIONS.map((opt) => (
              <React.Fragment key={opt.value}>
                {getSortOptions('all', opt)}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>

      {/* Compare Returns Dropdown */}
      <div styleName="filter-dropdown compare" onMouseEnter={handleCompareEnter} onMouseLeave={handleCompareLeave}>
        <button
          styleName="filter-btn"
          onClick={handleCompareToggle}
        >
          <span styleName="filter-icon">
            <Icon path={mdiCalendarToday} size="24px" />
          </span>
          <div styleName="filter-text">
            <span styleName="filter-label">COMPARE RETURNS</span>
            <span styleName="filter-value">
              {compareLabel} <span styleName="filter-vs">v/s</span> Today
              <Icon path={mdiChevronDown} size="16px" />
            </span>
          </div>
        </button>
        {isCompareOpen && (
          <div styleName="filter-menu compare-menu">
            <div styleName="compare-info-ctx">
              <Icon path={mdiLightbulb} size="18px" color="#5C5CBF" />
              <div styleName="compare-info">
                <div styleName="info">Iran-Israel-US War</div>
                <div styleName="time">Started on <b><i>28 Feb 2026</i></b></div>
              </div>
            </div>
            <div styleName="compare-header">SELECT OPTIONS</div>
            {COMPARE_OPTIONS.map((opt) => {
              const optFromDate = getFromDate(opt.value);
              return (
                <button
                  key={opt.value}
                  styleName={`compare-option ${compareRange === opt.value ? 'active' : ''}`}
                  onClick={() => onClickCompareOption(opt)}
                >
                  <div styleName="compare-row">
                    <div styleName="compare-cell">
                      <span styleName="compare-period">{opt.label}</span>
                      <span styleName="compare-date">{formatDate(optFromDate)}</span>
                    </div>
                    <span styleName="compare-vs">v/s</span>
                    <div styleName="compare-cell">
                      <span styleName="compare-period">Today</span>
                      <span styleName="compare-date">{formatDate(currentDate)}</span>
                    </div>
                    <span styleName="compare-arrow">›</span>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterControls;
